export var TypeActionGameTrackingShopOpenSource;
(function (TypeActionGameTrackingShopOpenSource) {
    TypeActionGameTrackingShopOpenSource["OpenSource"] = "ShopTracking > OpenSource";
    TypeActionGameTrackingShopOpenSource["PackageShow"] = "ShopTracking > PackageShow";
    TypeActionGameTrackingShopOpenSource["PackageSelect"] = "ShopTracking > PackageSelect";
    TypeActionGameTrackingShopOpenSource["BackToOffers"] = "ShopTracking > BackToOffers";
    TypeActionGameTrackingShopOpenSource["Checkout"] = "ShopTracking > Checkout";
    TypeActionGameTrackingShopOpenSource["ProviderSelect"] = "ShopTracking > ProviderSelect";
    TypeActionGameTrackingShopOpenSource["ProviderNavigate"] = "ShopTracking > ProviderNavigate";
})(TypeActionGameTrackingShopOpenSource || (TypeActionGameTrackingShopOpenSource = {}));
export var actionGameTrackingShopOpenSource = function (shopOpenSource) { return ({
    shopOpenSource: shopOpenSource,
    type: TypeActionGameTrackingShopOpenSource.OpenSource,
}); };
export var actionGameTrackingShopPackageShow = function (offerNameId) { return ({
    offerNameId: offerNameId,
    type: TypeActionGameTrackingShopOpenSource.PackageShow,
}); };
export var actionGameTrackingShopPackageSelect = function (offerNameId) { return ({
    offerNameId: offerNameId,
    type: TypeActionGameTrackingShopOpenSource.PackageSelect,
}); };
export var actionGameTrackingShopCheckout = function (offerNameId) { return ({
    offerNameId: offerNameId,
    type: TypeActionGameTrackingShopOpenSource.Checkout,
}); };
export var actionGameTrackingProviderSelect = function (providerId) { return ({
    providerId: providerId,
    type: TypeActionGameTrackingShopOpenSource.ProviderSelect,
}); };
export var actionGameTrackingShopBackToOffers = function () { return ({
    type: TypeActionGameTrackingShopOpenSource.BackToOffers,
}); };
export var actionGameTrackingShopProviderNavigate = function () { return ({
    type: TypeActionGameTrackingShopOpenSource.ProviderNavigate,
}); };



//////////////////
// WEBPACK FOOTER
// ./src/features/game-tracking/shop/actionGameTrackingShop.ts
// module id = 151
// module chunks = 3